import React from 'react';
import { Pencil, Check, X, ClipboardCopy, Send } from 'lucide-react'; // Dodano import Send

export default function OrderInfoSection({
  order,
  isEditingEmail,
  editedEmail,
  onEditEmailClick,
  onSaveEmail,
  onCancelEditEmail,
  onCopyPublicLink,
  copySuccessMessage,
  onEmailChange, // Callback to update editedEmail in the parent state
  onSendProjectToClient // Dodano nową akcję jako prop
}) {

  if (!order) {
    return null; // Or a loading indicator if preferred
  }

  return (
    <div className="order-info" style={{ fontSize: "1.1rem", marginBottom: 20 }}>
      <p>
        <strong>ID Zamówienia:</strong> {order.id}
      </p>
      <p>
        <strong>Nazwa:</strong> {order.orderName}
      </p>
      <div className="order-info-item email-section">
        <strong>E-mail:</strong>
        {isEditingEmail ? (
          <div className="email-edit-controls">
            <input
              type="email"
              value={editedEmail}
              onChange={(e) => onEmailChange(e.target.value)} // Use callback
              className="email-input"
            />
            {/* Pass editedEmail directly to save handler */}
            <button onClick={() => onSaveEmail(editedEmail)} className="admin-btn-icon admin-btn-icon-save" title="Zapisz">
              <Check size={16} />
            </button>
            {/* Pass original customOrderId back to cancel handler */}
            <button onClick={() => onCancelEditEmail(order.customOrderId)} className="admin-btn-icon admin-btn-icon-cancel" title="Anuluj">
              <X size={16} />
            </button>
          </div>
        ) : (
          <span className="email-display">
            {/* Display customOrderId */}
            {order.customOrderId || "(brak)"}
            {/* Pass current customOrderId to edit handler */}
            <button onClick={() => onEditEmailClick(order.customOrderId)} className="admin-btn-icon admin-btn-icon-edit" title="Edytuj e-mail">
              <Pencil size={14} />
            </button>
          </span>
        )}
      </div>
      <div className="order-info-item public-link-section">
         <strong>Link publiczny:</strong>
         <button onClick={onCopyPublicLink} className="admin-btn admin-btn-copy" title="Kopiuj link publiczny">
           <ClipboardCopy size={16} /> Kopiuj link
         </button>
         {copySuccessMessage && <span className="copy-success-msg">{copySuccessMessage}</span>}
      </div>
      {/* Dodany przycisk Wyślij projekt klientowi */}
      <div className="order-info-item send-link-section">
        <button
          className="admin-btn admin-btn-send" // Używamy podobnych klas jak dla kopiowania
          onClick={onSendProjectToClient}
          // Poprawiony warunek disabled - sprawdzamy customOrderId
          disabled={!order || !order.customOrderId || !order.customOrderId.includes('@')}
          title={!order || !order.customOrderId || !order.customOrderId.includes('@') ? "Najpierw zapisz poprawny email klienta" : "Wyślij email do klienta z linkiem do projektu"}
        >
          <Send size={16} style={{ marginRight: '5px' }} />
          Wyślij projekt klientowi
        </button>
      </div>
    </div>
  );
}
